module.exports = __webpack_public_path__ + "static/media/logo.de256f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/site/logo.png
// module id = 265
// module chunks = 0